import React from 'react';

// Font Awesome icons.
import { faRedditAlien } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import socialIcons from '../utils/constants/socialIcons';
const redditData = socialIcons.find(({ platform }) => platform === 'reddit') ?? {};

function DevLogButton({ className = '', buttonLabel = 'Dev Log', ...linkProps }) {
  return (
    <a href={redditData.url}  target="_blank" rel="noreferrer" className={className} {...linkProps}>
      <FontAwesomeIcon icon={faRedditAlien} size="lg" className="me-2" />
      {buttonLabel}
    </a>
  );
}

export default DevLogButton;

